import Validator from "dataphi-react-components/dist/Containers/FormScreen/FormComponent/Validator";

const indianPhoneValidator = (value) => (
  value && !/^(?:(?:\+|0{0,2})91(\s*[-]\s*)?|[0]?)?[789]\d{9}$/g.test(value) ?
      'Expected format: (0/+91XXXXXXXXXX) or (7/8/9XXXXXXXXX)' : undefined)

const OrganizationDefs = {
  closeButton: { text: "Cancel", className: "", hide: true },
  metaData: [
    {
      name: "inOrganizationName",
      type: "text",
      className: {
        fieldClassName: 'hsg-input',
        groupClassName: 'hsg-input-grp col-md-12 col-sm-12 col-xs-12',
        errorClassName: 'hsg-error',
        labelClassName: 'hsg-input-label'
      },
      label: "School Name",
      placeholder: "School Name",
      validation: [Validator.required]
    },
    {
      name: "inOrganizationAddress",
      type: "text",
      className: {
        fieldClassName: 'hsg-input',
        groupClassName: 'hsg-input-grp col-md-12 col-sm-12 col-xs-12',
        errorClassName: 'hsg-error',
        labelClassName: 'hsg-input-label'
      },
      label: "School Address",
      placeholder: "School Address",
      validation: [Validator.required]
    },
    {
      name: "countryName",
      type: "text",
      className: {
        fieldClassName: 'hsg-input',
        groupClassName: 'hsg-input-grp col-md-6 col-sm-6 col-xs-12',
        errorClassName: 'hsg-error',
        labelClassName: 'hsg-input-label'
      },
      label: "Country",
      placeholder: "Country",
      validation: [Validator.required],
      disabled: true
    },
    {
      name: "stateName",
      type: "text",
      className: {
        fieldClassName: 'hsg-input',
        groupClassName: 'hsg-input-grp col-md-6 col-sm-6 col-xs-12',
        errorClassName: 'hsg-error',
        labelClassName: 'hsg-input-label'
      },
      label: "State",
      placeholder: "State",
      validation: [Validator.required],
      disabled: true
    },
    {
      name: "cityName",
      type: "text",
      className: {
        fieldClassName: 'hsg-input',
        groupClassName: 'hsg-input-grp col-md-6 col-sm-6 col-xs-12',
        errorClassName: 'hsg-error',
        labelClassName: 'hsg-input-label'
      },
      label: "District",
      placeholder: "District",
      validation: [Validator.required],
      disabled: true
    },
    {
      name: "organizationPincode",
      type: "text",
      className: {
        fieldClassName: 'hsg-input',
        groupClassName: 'hsg-input-grp col-md-6 col-sm-6 col-xs-12',
        errorClassName: 'hsg-error',
        labelClassName: 'hsg-input-label'
      },
      label: "Pincode",
      placeholder: "Pincode",
      validation: [Validator.required],
      disabled: true
    },
    {
      name: "emailId",
      type: "email",
      className: {
        fieldClassName: 'hsg-input',
        groupClassName: 'hsg-input-grp col-md-12 col-sm-12 col-xs-12',
        errorClassName: 'hsg-error',
        labelClassName: 'hsg-input-label'
      },
      label: "Email Address",
      placeholder: "Email Address",
      validation: [Validator.required],
      disabled: true
    },
    {
      name: "contactNo",
      type: "text",
      className: {
        fieldClassName: 'hsg-input',
        groupClassName: 'hsg-input-grp col-md-12 col-sm-12 col-xs-12',
        errorClassName: 'hsg-error',
        labelClassName: 'hsg-input-label'
      },
      label: "Contact Number",
      placeholder: "Contact Number",
      validation: [indianPhoneValidator]
    }
  ]
};

export default OrganizationDefs;



// WEBPACK FOOTER //
// ./src/Containers/ManageProfileContainer/Component/OrganizationDefs.js